import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentService } from '../../services/component.service';
import { DeleteRequestModalComponent } from './delete-request/delete-request-modal.component';
/**
 * Account Component
 */
let AccountComponent = class AccountComponent {
    constructor(httpClient, sanitizer, compService, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.compService = compService;
        this.themeService = themeService;
        this.activeState = 'basic';
        this.passwordsSame = true;
        this.userData = {};
        this.password = {};
        this.bankAccounts = [];
        this.cryptoAccounts = [];
        this.notifications = {};
        this.updateNotifications = {};
        this.successColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.secondColor = '';
        this.textColor = '';
        this.hasFunds = false;
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
        });
    }
    ngOnInit() {
        localStorage.removeItem('draftData');
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.userData.password = 'necesmajci';
        this.userType = this.userData.user_type_id.type;
        this.httpClient.get('user/getselectednotifications').subscribe((result) => {
            this.notifications = result;
            this.updateNotifications = this.notifications;
        });
        this.httpClient.get('user/getbankaccounts').subscribe((result) => {
            this.bankAccounts = result;
        });
        this.httpClient.get('user/getcryptoaddresses').subscribe((result) => {
            this.cryptoAccounts = result;
        });
        this.httpClient.get('wallet/getwallets').subscribe((wallets) => {
            if (wallets['wallets']) {
                this.hasFunds = wallets['wallets'].some((wallet) => wallet.wallet.spendableTotal > 0);
            }
        });
    }
    setNav(active) {
        this.activeState = active;
    }
    comparePassword() {
        if (this.password.old !== this.password.new) {
            this.passwordsSame = false;
        }
        else {
            this.passwordsSame = true;
        }
    }
    changePassword() {
        this.httpClient.post('user/changepassword', {
            oldpassword: this.password.old,
            newpassword: this.password.newAgain
        }).subscribe((result) => {
            this.activeState = 'passwordChanged';
            setTimeout(function () {
                this.activeState = 'basic';
            }, 3000);
        }, (error) => {
            this.passwordsSame = false;
        });
    }
    deleteCrypto(event, id) {
        this.httpClient.post('user/deletesavedaddress/', {
            address_id: id
        }).subscribe((result) => {
            event.srcElement.parentElement.parentElement.remove();
        });
    }
    deleteBank(event, id) {
        this.httpClient.post('user/deletebankaccount/', {
            account_id: id
        }).subscribe((result) => {
            event.srcElement.parentElement.parentElement.remove();
        });
    }
    updateNotification() {
        if (!this.notifications.service_information_sms) {
            this.notifications.service_information_sms = 'disable';
        }
        else {
            this.notifications.service_information_sms = 'enable';
        }
        if (!this.notifications.newsletter) {
            this.notifications.newsletter = 'disable';
        }
        else {
            this.notifications.newsletter = 'enable';
        }
        if (!this.notifications.transactions_sms) {
            this.notifications.transactions_sms = 'disable';
        }
        else {
            this.notifications.transactions_sms = 'enable';
        }
        this.httpClient.post('user/updatenotifications', this.notifications).subscribe((result) => {
            this.notifications = JSON.parse(result['_body']);
        });
    }
    deleteAccountPopup() {
        this.compService.openModal(DeleteRequestModalComponent, { hasFunds: this.hasFunds });
    }
};
AccountComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: ComponentService },
    { type: WebsiteThemeService }
];
AccountComponent = __decorate([
    Component({
        selector: 'ecd-account',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./account.component.html")).default
    })
], AccountComponent);
export { AccountComponent };
